import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    navigate('/login');
  }, [logout, navigate]);

  return (
    <div>
      <h1 className="text-center text-xl font-bold mt-10">Successfully logged out!</h1>
      <h1 className="text-center text-xl font-bold mt-10">Redirecting to login </h1>
    </div>
  );
};

export default Logout;
